import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationService } from './core/modules/auth-core/data/service/authentication.service';
import { CoreModule } from './core/core.module';
import { CommunityGuard } from './guard/community.guard';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { NgChartsModule } from 'ng2-charts';
import { AdminGuard } from './guard/access.guard';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule, 
    SharedModule,
    IonicModule.forRoot(
      {
        scrollAssist: false
      }
    ), 
    AppRoutingModule,
    CoreModule,
    GoogleTagManagerModule.forRoot({
      // PROD
      id: 'GTM-PV3K7DC'
      // STAGING
      // id: 'GTM-TFW43PR'
    }),
    NgChartsModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AuthenticationService,
    CommunityGuard,
    AdminGuard
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
